var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_24267_1294)" },
      React.createElement("path", { d: "M9.117-1.895c6.082 0 11.012 4.93 11.012 11.012 0 6.082-4.93 11.012-11.012 11.012-6.081 0-11.012-4.93-11.012-11.012 0-6.082 4.93-11.012 11.012-11.012zm3.391 7.796l-4.905 4.905L5.726 8.93a1.239 1.239 0 1 0-1.752 1.752l2.753 2.753a1.239 1.239 0 0 0 1.752 0l5.781-5.781a1.239 1.239 0 1 0-1.752-1.752z", fill: "#fff" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_24267_1294" },
        React.createElement("rect", { width: "100%", height: "100%", rx: "9", fill: "#fff" })
      )
    )
  );
});